













































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import TripsModule from "@/store/modules/trips";
import tripModule from "@/store/modules/trip";
import { getModule } from "vuex-module-decorators";
import { TripEntity } from "../api/types";
import TripImage from "@/components/TripImage.vue";
import MatchList from "@/components/MatchList.vue";
import TripChat from "@/components/TripChat.vue";
import WriteMessage from "@/components/WriteMessage.vue";
import Feed from "@/components/Feed.vue";

const trips = getModule(TripsModule);

@Component({
  components: {
    TripImage,
    MatchList,
    TripChat,
    Feed
  }
})
export default class ViewTrip extends Vue {
  segment = 'people';

  created() {
    
    let tripId = this.$route.params.id;
    tripModule.bindTrip(tripId);
    console.log("Bound trip to " + tripId);
    //console.log(this.$route);
  }

  changeSegment(event: any) {
    this.segment = event.detail.value;
  }

  createMessage() {
    this.$ionic.modalController.create({component: WriteMessage}).then(m => m.present())

    //this.$ionic.modalController
    //  .create({component: WriteMessage}).then(m => m.present());
  }

  get trip() {
    return tripModule.trip;
  }
}
